import React, { useState, useEffect } from 'react';

import { Button, Typography, Switch } from '@mui/material';
import * as MATERIEL_ICONS from '@mui/icons-material/';
import service from '../service';
import { toast } from 'react-toastify';
import { useBoundStore } from '../../../../stores';

import { user_fields } from '../constants/create_user_fields';
import CustomInput from '../../../../components/CustomInput';
import { useNavigate } from 'react-router-dom';

function CreateUserDrawer() {
  const [valid, setValid] = useState(false);
  const toggleRightDrawer = useBoundStore((state) => state.toggleRightDrawer);

  const [userFormData, setUserFormData] = useState({
    name: '',
    surname: '',
    username: '',
    password: '',
    phone: null,
  });

  const navigate = useNavigate();

  const validateForm = () => {
    if (
      userFormData.name &&
      userFormData.surname &&
      userFormData.username &&
      userFormData.password) {
      setValid(true);
    } else {
      setValid(false);
    }
  };

  const handleSave = async () => {
    // console.log(userFormData);
    await service.saveUser({
      name: userFormData.name,
      surname: userFormData.surname,
      username: userFormData.username,
      password: userFormData.password,
      ...userFormData?.phone !== null ? { phone: userFormData.phone } : null,
    }).then((response) => {
      if (response?.status === 200 || response?.status === 201) {
        toast.success('Kullanıcı başarıyla oluşturuldu.');
      } else {
        toast.error('Kullanıcı oluşturulurken hata oluştu.');
      }
      navigate('/definitions/users');
      toggleRightDrawer();
    });
  };

  useEffect(() => {
    validateForm();
  }, [userFormData]);

  return (
    <div className="mt-5">
      <div className="px-2">
        <Typography variant="h6">Kullanıcı Ekle</Typography>
      </div>
      <div>
        <>
          <div className="flex flex-col">
            <div className="flex flex-row flex-wrap justify-center items-center gap-4 w-full my-5">
              {user_fields().map((field, index) => {
                return (
                  <div className=" flex w-full" key={index}>
                    <CustomInput
                      key={index}
                      type={field.type}
                      inputType={field.inputType}
                      defaultValue={field.defaultValue}
                      items={field.items}
                      label={field.placeHolder}
                      value={userFormData[field.key]}
                      fullWidth={true}
                      size={'small'}
                      onChange={(key, value) => {

                        setUserFormData((prevFormData) => ({
                          ...prevFormData,
                          [field.key]: value,
                        }));
                      }
                      }
                    />
                  </div>
                );
              })}
              <Button
                disabled={!valid}
                variant="contained"
                color="primary"
                startIcon={<MATERIEL_ICONS.Save />}
                onClick={() => handleSave()}
                className="mx-2"
              >
                Kaydet
              </Button>
            </div>
          </div>
        </>
      </div>
    </div>
  );
}

export default CreateUserDrawer;
